(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("manageSubeventController", manageSubeventController);

  manageSubeventController.$inject = [
    "$rootScope",
    "$scope",
    "$timeout",
    "$uibModalInstance",
    "EventsApi",
    "UploadsApi",
    "alerts",
    "locations",
    "ISO3166",
    "handleError",
    "eventId",
    "subeventId",
    "Helpers",
    "thisSiteSettings",
  ];

  function manageSubeventController(
    $rootScope,
    $scope,
    $timeout,
    $uibModalInstance,
    EventsApi,
    UploadsApi,
    Alerts,
    locations,
    countries,
    handleError,
    eventId,
    subeventId,
    Helpers,
    thisSiteSettings,
  ) {
    var vm = this;

    vm.countries = countries.countryToCode;
    vm.formErrors = {};
    vm.isLoading = false;
    vm.isLoadingMessage = "Loading...";
    vm.eventId = eventId;
    vm.subeventId = subeventId;
    vm.createNewSubevent = subeventId === null;
    vm.endDateOptions = [
      { label: "No", value: false },
      { label: "Yes", value: true },
    ];
    vm.subevent = {};
    vm.same = {
      datetime: false,
      location: false,
    };
    vm.image = null;
    vm.imageUploadOptions = {
      resize: true,
      resizeShape: "rectangle",
      resizeSize: {
        w: 1140,
        h: 400,
      },
      resizeAspectRatio: 4.30769230769,
    };

    vm.close = $uibModalInstance.close;
    vm.handleImage = handleImage;
    vm.handleImageError = handleImageError;
    vm.saveSubevent = saveSubevent;
    vm.selectLocation = selectLocation;
    vm.searchLocations = searchLocations;
    vm.currencySymbol = thisSiteSettings.currency_symbol;

    /**
     * Handles the image chosen by the user.
     *
     * @param  {String}
     * @return {void}
     */
    function handleImage(file) {
      vm.image = file;
    }

    /**
     * Shows file errors.
     *
     * @param  {Object}
     * @return {void}
     */
    function handleImageError(imageError) {
      vm.formErrors = angular.merge(vm.formErrors, imageError);
    }

    /**
     * Get information about the event that this subevent is part of, then
     * get the subevent information.
     *
     * @return {void}
     */
    function getSubevent() {
      EventsApi.get({ id: eventId }, function success(response) {
        vm.event = response.data;

        if (subeventId) {
          return EventsApi.get({ id: subeventId }, function success(response) {
            vm.subevent = response.data;

            vm.subevent.startsAt = window.moment
              .tz(vm.subevent.starts_at, "UTC")
              .tz("Europe/London")
              .toDate();
            vm.subevent.endsAt = window.moment
              .tz(vm.subevent.ends_at, "UTC")
              .tz("Europe/London")
              .toDate();
            vm.hasEndDate = vm.subevent.ends_at !== null;

            // Determine if the datetime and location values are the same.
            if (
              vm.event.starts_at === vm.subevent.starts_at &&
              vm.event.ends_at === vm.subevent.ends_at
            ) {
              vm.same.datetime = true;
            }

            if (
              JSON.stringify(vm.event.latlng) ===
                JSON.stringify(vm.subevent.latlng) ||
              JSON.stringify(vm.event.address) ===
                JSON.stringify(vm.subevent.address)
            ) {
              vm.same.location = true;
            }

            vm.isLoading = false;
          });
        }

        vm.same = {
          datetime: true,
          location: true,
        };
        vm.isLoading = false;
      });
    }

    /**
     * Attempts to create/update/save an subevent.
     *
     * @return {void}
     */
    function saveSubevent() {
      var funcName = vm.createNewSubevent ? "save" : "update";
      var params = vm.createNewSubevent ? {} : { id: vm.subeventId };

      if (vm.same.datetime) {
        vm.subevent.starts_at = window
          .moment(vm.event.starts_at)
          .format(Helpers.isoFormat);
        vm.subevent.ends_at = vm.event.ends_at
          ? window.moment(vm.event.ends_at).format(Helpers.isoFormat)
          : undefined;
      } else {
        vm.subevent.starts_at = window.moment
          .tz(vm.subevent.startsAt, "Europe/London")
          .tz("UTC")
          .format(Helpers.isoFormat);
        vm.subevent.ends_at = window.moment
          .tz(vm.subevent.endsAt, "Europe/London")
          .tz("UTC")
          .format(Helpers.isoFormat);
      }

      if (vm.same.location) {
        vm.subevent.address = vm.event.address;
        vm.subevent.latlng = vm.event.latlng;
      }

      // If tickets are on sale for a price other than zero, then payment required should be true.
      vm.subevent.payment_required = vm.subevent.price > 0 ? true : false;
      vm.subevent.status = vm.event.status;
      vm.subevent.private = vm.event.private;
      vm.subevent.parent_id = vm.eventId;

      vm.isLoading = true;

      // !TODO: path should be "event", but not implemented in API yet
      UploadsApi.uploadImage(vm.image, "site").then(
        function (img) {
          // add uploaded image path to event
          if (img && img.path) {
            vm.subevent.img = img.path;
          }

          // set relevant loading message
          vm.isLoadingMessage = vm.createNewSubevent
            ? "Creating new subevent..."
            : "Saving subevent...";

          EventsApi[funcName](
            params,
            vm.subevent,
            function success(response) {
              $timeout(function () {
                vm.isLoading = false;
                $uibModalInstance.close(response.data);
              }, 400);
            },
            function error(error) {
              vm.isLoading = false;
              vm.errors = error.data;
            },
          ).suppressValidationAlerts();
        },
        function handleUploadError(err) {
          vm.isLoading = false;
          vm.formErrors = err.data;
        },
        function handleUploadProgress(progress) {
          vm.isLoadingProgress = progress;
          if (progress === 100) {
            vm.isLoadingProgress = 0;
            vm.isLoadingMessage = "Saving image...";
          }
        },
      );
    }

    /**
     * Search for locations from Google.
     *
     * @param  {string}
     * @return {void}
     */
    function searchLocations(searchQuery) {
      locations.find(searchQuery).then(
        function (results) {
          vm.locationSuggestions = results;
        },
        function (error) {
          handleError(error);
        },
      );
    }

    /**
     * Select a location and fill out the details.
     *
     * @param  {object}
     * @return {void}
     */
    function selectLocation(location) {
      locations.getDetails(location.placeId).then(
        function (details) {
          vm.subevent.address = details.address;
          vm.subevent.latlng = details.coords;
        },
        function (error) {
          handleError(error);
        },
      );
    }

    getSubevent();
  }
})(angular);
